module.exports = __webpack_public_path__ + "static/media/christie.58c949b1.png";